import {
  airBookingApi,
  SingleFlightItineraryResponse,
} from "@b2bportal/air-booking-api";
import { axiosInstance, trackEvent } from "@hopper-b2b/api";
import { NETWORK_CALL_FAILED } from "@hopper-b2b/types";

export const fetchFlightReservation = async (
  itineraryId: string,
  headerToken?: string
): Promise<SingleFlightItineraryResponse> => {
  const body: { itineraryId: string; referenceDateTime: string } = {
    itineraryId: itineraryId,
    referenceDateTime: new Date().toISOString(),
  };
  try {
    const res = await airBookingApi(
      axiosInstance
    ).apiV0ItineraryFlightSinglePut(
      body,
      headerToken && {
        headers: {
          "Trip-Access-Token": headerToken,
        },
      }
    );
    const { data } = res;
    return data;
  } catch (e) {
    trackEvent({
      eventName: NETWORK_CALL_FAILED,
      properties: {
        url: window.location.pathname,
      },
    });
    throw e;
  }
};
